import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";
import { useParams } from "react-router-dom";

export const useGetQuestChapters = () => {
  const [questChapters, setQuestChapters] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { questId } = useParams();
  const { axiosInstance } = useAxios();

  const getStudentQuestChapters = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axiosInstance.get(
        `${TENANT_DOMAIN}/student/quest/${questId}/chapters`
      );

      const data = response?.data?.data.chapters;
      setQuestChapters(data ?? null);
    } catch (err) {
      setQuestChapters(null);

      if (err?.response?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return { questChapters, loading, error, getStudentQuestChapters };
};
